import {
    LanguageAvailabilityByProduct,
    LegacyGender
} from '../constants-types/Enums';

export class BehavioralReportConfiguration {
    isManagement = false;
    isInfluencing = false;
    isSelling = false;
    languageLocale: string;
    languageOptions: LanguageAvailabilityByProduct;

    constructor(obj?: Partial<BehavioralReportConfiguration>) {
        Object.assign(this, obj);
    }
}

export class OnboardingBehavioralReportConfiguration {
    gender: string = LegacyGender[LegacyGender.Male];
    isManagement = false;
    isInfluencing = false;
    isSelling = false;
    kitLanguage: string;
    languageLocale: string;

    emailTo?: string;
    emailSubject?: string;
    emailMessageBody?: string;

    constructor(obj?: Partial<OnboardingBehavioralReportConfiguration>) {
        Object.assign(this, obj);
    }
}

export class BehavioralReportConfigEmailDetails {
    emailTo?: string;
    emailSubject?: string;
    emailMessageBody?: string;
}

export type ReportRetrievalType = 'Print' | 'Email' | 'Download';
